import { z } from 'zod'

import { SIDES } from '@/pages/instruments/new-instrument/constants/sides'

export const sideSchema = z.enum(SIDES)
